import { Component, inject, OnInit, signal, WritableSignal } from '@angular/core';
import { DashboardStore } from '../stores/dashboard.store';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { SelectModule } from 'primeng/select';
import { TableModule } from 'primeng/table';
import { Dashboard } from '../models/dashboard';
import { MessageService } from 'primeng/api';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmationService } from 'primeng/api';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-dashboard-list',
  imports: [
    CommonModule,
    SelectModule,
    FormsModule,
    TableModule,
    ConfirmDialogModule,
    ButtonModule,
  ],
  templateUrl: './dashboard-list.component.html',
  styleUrl: './dashboard-list.component.css',
})
export class DashboardListComponent implements OnInit {
  // Signal für die Liste der Dashboards
  dashboards: WritableSignal<Dashboard[]> = signal([]);

  readonly managementEnabled = (environment as any).dashboardManagementEnabled === true;

  // Abhängigkeiten werden über Dependency Injection bereitgestellt
  private readonly store = inject(DashboardStore);
  private readonly messageService = inject(MessageService);
  private readonly router = inject(Router);
  private readonly route = inject(ActivatedRoute);
  private readonly confirmationService = inject(ConfirmationService);

  // Initialisierung der Komponente
  ngOnInit() {
    // Daten aus dem Resolver abrufen und in das Signal setzen
    this.route.data.subscribe((data) => {
      this.dashboards.set(data['dashboards'] ?? []);
    });
  }

  // Methode zum Bearbeiten eines Dashboards
  editDashboard(dashboard: Dashboard) {
    // Navigiert zur Update-Seite des Dashboards
    this.router.navigate(['/dashboard', dashboard.id, 'update']);
  }

  // Methode zum Löschen eines Dashboards
  deleteDashboard(dashboard: Dashboard) {
    // Bestätigungsdialog anzeigen
    this.confirmationService.confirm({
      message: 'Möchten Sie diesen Eintrag wirklich löschen?',
      header: 'Löschen bestätigen',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Ja',
      rejectLabel: 'Nein',
      accept: () => {
        // Dashboard löschen, wenn der Benutzer bestätigt
        this.store.deleteDashboard(dashboard.id).subscribe((success) => {
          if (success) {
            // Dashboard aus der Liste entfernen
            this.dashboards.set(
              this.dashboards().filter((d) => d.id !== dashboard.id)
            );
            // Erfolgsnachricht anzeigen
            this.messageService.add({
              life: 3000,
              closable: true,
              severity: 'success',
              summary: 'Erfolgreich',
              detail: 'Dashboard erfolgreich gelöscht.',
            });
          }
        });
      },
      reject: () => {
        // Aktion abbrechen
      },
    });
  }
}
